"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("./components/styles");

var _FieldWrapper = _interopRequireDefault(require("./components/FieldWrapper"));

var _designLanguage = require("@doordash/design-language");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("./Select"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

var _lodash2 = _interopRequireDefault(require("lodash.padstart"));

var _lodash3 = _interopRequireDefault(require("lodash.range"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HOURS = (0, _lodash3["default"])(1, 13).map(function (hour) {
  return {
    name: String(hour),
    value: String(hour)
  };
});

var generateMinuteOptions = function generateMinuteOptions(_ref) {
  var step = _ref.step;
  return (0, _lodash3["default"])(0, 60, step).map(function (minute) {
    return {
      name: (0, _lodash2["default"])(String(minute), 2, '0'),
      value: String(minute)
    };
  });
};

var MINUTES = {
  One: generateMinuteOptions({
    step: 1
  }),
  Five: generateMinuteOptions({
    step: 5
  }),
  Ten: generateMinuteOptions({
    step: 10
  }),
  Fifteen: generateMinuteOptions({
    step: 15
  }),
  Twenty: generateMinuteOptions({
    step: 20
  }),
  Thirty: generateMinuteOptions({
    step: 30
  })
};
var PERIODS = [{
  name: 'AM',
  value: 'AM'
}, {
  name: 'PM',
  value: 'PM'
}];

var TimeField = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TimeField, _React$PureComponent);

  var _super = _createSuper(TimeField);

  function TimeField(props) {
    var _this;

    _classCallCheck(this, TimeField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref2) {
      var _ref2$hour = _ref2.hour,
          hour = _ref2$hour === void 0 ? _this.state.hour : _ref2$hour,
          _ref2$minute = _ref2.minute,
          minute = _ref2$minute === void 0 ? _this.state.minute : _ref2$minute,
          _ref2$period = _ref2.period,
          period = _ref2$period === void 0 ? _this.state.period : _ref2$period;

      _this.setState({
        hour: hour,
        minute: minute,
        period: period
      }, function () {
        _this.props.onChange(_this.state);
      });
    });

    _this.state = _objectSpread({}, props.value);
    return _this;
  }

  _createClass(TimeField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value.hour !== this.props.value.hour || nextProps.value.minute !== this.props.value.minute || nextProps.value.period !== this.props.value.period) {
        this.setState(_objectSpread({}, nextProps.value));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          description = _this$props.description,
          hint = _this$props.hint,
          error = _this$props.error,
          isDisabled = _this$props.isDisabled,
          isLabelHidden = _this$props.isLabelHidden,
          isRounded = _this$props.isRounded,
          renderBeforeContent = _this$props.renderBeforeContent,
          renderAfterContent = _this$props.renderAfterContent,
          minuteInterval = _this$props.minuteInterval,
          size = _this$props.size;
      return /*#__PURE__*/_react["default"].createElement(_FieldWrapper["default"], {
        label: label,
        description: description,
        hint: hint,
        error: error,
        isDisabled: isDisabled,
        isLabelHidden: isLabelHidden,
        renderBeforeContent: renderBeforeContent,
        renderAfterContent: renderAfterContent,
        isBare: true,
        size: size
      }, /*#__PURE__*/_react["default"].createElement(_styles.TimeWrapper, null, /*#__PURE__*/_react["default"].createElement(_designLanguage.Inline, {
        size: _designLanguage.Inline.Sizes.XSmall
      }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: this.state.hour,
        label: "Hour",
        isLabelHidden: true,
        isDisabled: isDisabled,
        isRounded: isRounded,
        disabledValue: "HH",
        options: HOURS,
        onChange: function onChange(hour) {
          return _this2.handleChange({
            hour: hour
          });
        },
        size: size,
        error: typeof error === 'boolean' ? error : error && error.length > 0
      })), /*#__PURE__*/_react["default"].createElement(_designLanguage.Inline, {
        tag: _styles.TimeSeparatorContainer,
        size: _designLanguage.Inline.Sizes.XSmall
      }, ":"), /*#__PURE__*/_react["default"].createElement(_designLanguage.Inline, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: this.state.minute,
        label: "Minute",
        isLabelHidden: true,
        isDisabled: isDisabled,
        isRounded: isRounded,
        disabledValue: "MM",
        options: MINUTES[minuteInterval],
        onChange: function onChange(minute) {
          return _this2.handleChange({
            minute: minute
          });
        },
        size: size,
        error: typeof error === 'boolean' ? error : error && error.length > 0
      })), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: this.state.period,
        label: "Period",
        isLabelHidden: true,
        isDisabled: isDisabled,
        isRounded: isRounded,
        disabledValue: "--",
        options: PERIODS,
        onChange: function onChange(period) {
          return _this2.handleChange({
            period: period
          });
        },
        size: size,
        error: typeof error === 'boolean' ? error : error && error.length > 0
      })));
    }
  }]);

  return TimeField;
}(_react["default"].PureComponent);

_defineProperty(TimeField, "MinuteIntervals", Object.keys(MINUTES).reduce(function (acc, key) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, key));
}, {}));

_defineProperty(TimeField, "propTypes", _objectSpread(_objectSpread({}, (0, _lodash["default"])(_Select["default"].propTypes, ['options'])), {}, {
  value: _propTypes["default"].shape({
    minute: _propTypes["default"].string.isRequired,
    hour: _propTypes["default"].string.isRequired,
    period: _propTypes["default"].string.isRequired
  }).isRequired,
  minuteInterval: _propTypes["default"].oneOf(Object.values(TimeField.MinuteIntervals))
}));

_defineProperty(TimeField, "defaultProps", _Select["default"].defaultProps);

TimeField.Sizes = _FieldWrapper["default"].Sizes;
TimeField.defaultProps = {
  size: TimeField.Sizes.Medium,
  minuteInterval: TimeField.MinuteIntervals.Fifteen
};
var _default = TimeField;
exports["default"] = _default;